var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.users),function(user){return _c('UsersInvitationsRow',{key:user.tempId,attrs:{"user":user,"roles":_vm.roles,"groups":_vm.groups,"label-categories":_vm.labelCategories,"force-error":_vm.duplicateEmails.includes(user.email)},on:{"change":_vm.handleChange,"delete":function($event){return _vm.handleDelete(user.tempId)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }